import { css } from '@/styled-system/css';

export const pageContainer = css({
  maxWidth: '600px',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingTop: '3x',
  paddingRight: '2x',
  paddingBottom: '4x',
  paddingLeft: '2x',
});

export const pageTitle = css({
  fontSize: 'xl',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  marginBottom: '1x',
  textAlign: 'center',
});

export const pageSubtitle = css({
  fontSize: 'md',
  color: 'hpxGrey600',
  textAlign: 'center',
  marginBottom: '3x',
});

export const searchSection = css({
  position: 'relative',
  marginBottom: '3x',
});

export const searchInput = css({
  width: '100%',
  paddingTop: '1x',
  paddingRight: '2x',
  paddingBottom: '1x',
  paddingLeft: '2x',
  fontSize: 'md',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  outlineStyle: 'none',
  _focus: {
    borderColor: 'hpxTeal500',
    boxShadow: '0 0 0 2px token(colors.hpxTeal100)',
  },
});

export const suggestionsDropdown = css({
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  background: 'hpxWhite',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  marginTop: 'xs',
  zIndex: 'zIndexParent',
  maxHeight: '250px',
  overflowY: 'auto',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
});

export const suggestionItem = css({
  paddingTop: '1x',
  paddingRight: '2x',
  paddingBottom: '1x',
  paddingLeft: '2x',
  fontSize: 'sm',
  color: 'hpxBlue600',
  cursor: 'pointer',
  _hover: {
    background: 'hpxGrey100',
  },
});

export const suggestionItemActive = css({
  background: 'hpxGrey100',
});

export const listingSection = css({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '3x',
});

export const errorText = css({
  fontSize: 'md',
  color: 'hpxRed400',
  textAlign: 'center',
  paddingTop: '4x',
  paddingRight: '2x',
  paddingBottom: '4x',
  paddingLeft: '2x',
});

export const loadingText = css({
  fontSize: 'md',
  color: 'hpxGrey600',
  textAlign: 'center',
  paddingTop: '4x',
  paddingRight: '2x',
  paddingBottom: '4x',
  paddingLeft: '2x',
});

export const completedContainer = css({
  textAlign: 'center',
  paddingTop: '4x',
  paddingRight: '2x',
  paddingBottom: '4x',
  paddingLeft: '2x',
});

export const completedTitle = css({
  fontSize: 'xl',
  fontWeight: 'bold',
  color: 'hpxTeal600',
  marginTop: '3x',
  marginBottom: '2x',
});

export const completedMessage = css({
  fontSize: 'md',
  color: 'hpxBlue500',
  marginBottom: '3x',
});
